export default __webpack_public_path__ + "static/media/gallery-wip-pommel_09.785e98da.jpg";